export const HttpPrefixerService = angular
    .module('app.components.httpPrefix.httpPrefixerService', [])
    .factory('httpPrefixer', () => {
        return {
            prefixUrl: (urlToPrefix, forceHtps) => {
                // Need to add prefix if we don't have http:// prefix already AND we don't have part of it
                let httpPrefixRegex = /^(https?):\/\//i;
                if (urlToPrefix && !httpPrefixRegex.test(urlToPrefix) &&
                    'http://'.indexOf(urlToPrefix) !== 0 && 'https://'.indexOf(urlToPrefix) !== 0) {
                    return forceHtps ? `https://${urlToPrefix}` : `http://${urlToPrefix}`;
                }
                return urlToPrefix;
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/httpPrefix/httpPrefixer.service.js